<template>
  <div class="student-information-form">
    <div
      v-if="hasRequiredFields || hasOptionalFields"
      class="bg-lightest-gray col rounded p-4"
    >
      <div class="row">
        <div v-if="hasRequiredFields" class="col-12 mb-3">
          {{ $t('SETTINGS.TEXT.MANDATORY_INFORMATION') }}
        </div>
        <div
          class="col-md-6"
          v-for="field in requiredFields"
          :key="field.field"
        >
          <HMTextInput
            :label="field.label"
            rules="required"
            v-model="localStudent[field.field]"
          />
        </div>
      </div>
      <HMCollapse v-if="hasOptionalFields">
        <template v-slot:title>
          {{ $t('SETTINGS.TEXT.OPTIONAL_INFORMATION') }} </template
        >>
        <template v-slot:content>
          <div class="row mt-3">
            <div
              class="col-md-6"
              v-for="field in optionalFields"
              :key="field.field"
            >
              <HMTextInput
                :label="field.label"
                v-model="localStudent[field.field]"
              />
            </div>
          </div> </template
        >>
      </HMCollapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { HMCollapse } from '../common';

export default {
  name: 'StudentCheckoutInformationForm',
  components: {
    HMCollapse,
  },
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      student: 'user/student',
    }),
    studentFields() {
      return [
        {
          field: 'address',
          label: this.$t('STUDIO.LABELS.ADDRESS'),
          displayed: this.studio?.address_displayed,
          required: this.studio?.address_required,
          value: this.student?.address,
        },
        {
          field: 'city',
          label: this.$t('SETTINGS.LABEL.CITY'),
          displayed: this.studio?.city_displayed,
          required: this.studio?.city_required,
          value: this.student?.city,
        },
        {
          field: 'zipcode',
          label: this.$t('SETTINGS.LABEL.ZIP_CODE'),
          displayed: this.studio?.zip_displayed,
          required: this.studio?.zip_required,
          value: this.student?.zipcode,
        },
        {
          field: 'state',
          label: this.$t('SETTINGS.LABEL.STATE_PROVINCE'),
          displayed: this.studio?.state_displayed,
          required: this.studio?.state_required,
          value: this.student?.state,
        },
        {
          field: 'country',
          label: this.$t('SETTINGS.LABEL.COUNTRY'),
          displayed: this.studio?.country_displayed,
          required: this.studio?.country_required,
          value: this.student?.country,
        },
        {
          field: 'phone',
          label: this.$t('STUDIO.LABELS.PHONE'),
          displayed: this.studio?.phone_number_displayed,
          required: this.studio?.phone_number_required,
          value: this.student?.phone,
        },
        {
          field: 'business_name',
          label: this.$t('SETTINGS.LABEL.BUSINESS_NAME'),
          displayed: this.studio?.business_name_displayed,
          required: this.studio?.business_name_required,
          value: this.student?.business_name,
        },
        {
          field: 'tax_id',
          label: this.$t('SETTINGS.LABEL.TAX_ID'),
          displayed: this.studio?.tax_id_displayed,
          required: this.studio?.tax_id_required,
          value: this.student?.tax_id,
        },
      ];
    },
    displayedFields() {
      return this.studentFields.filter(f => f.displayed);
    },
    requiredFields() {
      return this.displayedFields.filter(f => f.required);
    },
    optionalFields() {
      return this.displayedFields.filter(f => !f.required);
    },
    hasRequiredFields() {
      return this.requiredFields.length > 0;
    },
    hasOptionalFields() {
      return this.optionalFields.length > 0;
    },
  },
  data() {
    return {
      localStudent: {},
    };
  },
  watch: {
    student: {
      handler(student) {
        if (student) {
          this.localStudent = _.cloneDeep(student);
        }
      },
      immediate: true,
    },
    localStudent: {
      handler(localStudent) {
        this.$emit(
          'input',
          _.pick(
            localStudent,
            this.displayedFields.map(f => f.field)
          )
        );
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
